export default {
  // Search
  templateName: 'Template Name',
  templateNamePlaceholder: 'Enter template name',
  productName: 'Product Name',
  productNamePlaceholder: 'Enter product name',
  // Table columns
  colTemplateName: 'Template Name',
  colRelatedProduct: 'Related Products',
  colIsDefault: 'Default Template',
  // Default template
  defaultOn: 'On',
  defaultOff: 'Off',
  defaultOnSuccess: 'Set as default template',
  defaultOffSuccess: 'Default template disabled',
  defaultChangeFailed: 'Failed to update default template status',
  // Actions
  editTemplate: 'Edit Template',
  addProduct: 'Add Product',
  // Add product modal
  addProductTitle: 'Add Related Product',
  selectProduct: 'Select Product',
  selectProductPlaceholder: 'Please select a product',
  productRequired: 'Please select a product',
  addProductSuccess: 'Product added successfully',
  addProductFailed: 'Failed to add product',
  // Delete product
  deleteProductSuccess: 'Product deleted successfully',
  deleteProductFailed: 'Failed to delete product',
  // Edit template
  editTemplateSuccess: 'Template updated successfully',
  editTemplateFailed: 'Failed to update template',
  // View products modal
  viewProductsTitle: 'Related Products',
  colProductId: 'Product ID',
  colProductName: 'Product Name',
  // Empty state
  emptyText: 'No template data',
};
